// @flow
import * as React from 'react';
import {
    AddressFirstField,
    AddressSecondField,
    AddressThirdField,
    AddressFourthField,
    PostCodeField,
    CountrySelectField,
    PhoneField
} from '../field';
import Buttons from '../button';

const AddressComponent = () => (
    <form>
        <CountrySelectField />
        <AddressFirstField />
        <AddressSecondField />
        <AddressThirdField />
        <AddressFourthField />
        <PostCodeField />

        <PhoneField />

        <Buttons back />
    </form>
);

export default AddressComponent;
